import Vue from 'vue'
import ComponentCssClassPlugin from 'vue-components/plugins/component-css-class/component-css-class'

Vue.use(ComponentCssClassPlugin)



// WEBPACK FOOTER //
// ./src/plugins/component-css-class.js